<template>
	<view style="width: 100%;height: 100%;">
		<camera device-position="back" flash="off" style="width: 100%; height: 100%;" @error="cameraError" @stop="stopError" @initdone="setCameraLock"></camera>
			<view style="display: flex;align-items: center;justify-content: center;height: 20%;width: 100%;position: absolute;bottom: 36%;z-index: 999;">
				<view class="btn-father" @tap="takeImg">
					<uni-icons type="circle-filled" size="160r" color="#fff"></uni-icons>
					<text class="btn-desc" style="margin-left: 20rpx;margin-top: 100rpx;font-size: 32rpx;width: 130rpx;">拍照识别</text>
				</view>
			</view>	
			<view style="display: flex;align-items: center;justify-content: center;height: 20%;width: 100%;position: absolute;bottom: 20%;z-index: 999;">
				<view class="btn-father" @tap="chooseImgFile">
					<uni-icons type="image" size="80r" color="#fff" style="margin-left: 20rpx;"></uni-icons>
					<text class="btn-desc" style="margin-left: 12rpx;">打开相册</text>
				</view>
				<view class="btn-father" @tap="back">
					<uni-icons type="compose" size="80r" color="#fff"></uni-icons>
					<text class="btn-desc" style="margin-left: -10rpx;">手动录入</text>
				</view>
			</view>
			<!-- <view style="display: flex;align-items: center;justify-content: center;height: 20%;width: 100%;position: absolute;bottom: 6%;">
				<view class="btn-father">
					<uni-icons type="bars" size="60r" color="#fff" style="margin-left: 16rpx;"></uni-icons>
					<text class="btn-desc">历史记录</text>
				</view>
			</view> -->
			<!-- <image mode="widthFix" :src="src"></image> -->
			<view class="zz">
				<view style="border-left: 10rpx solid #fff;border-top: 10rpx solid #fff;width: 25rpx;height: 25rpx;position: absolute;left: 0;top: 0;"></view>
				<view style="border-top: 10rpx solid #fff;border-right: 10rpx solid #fff;width: 25rpx;height: 25rpx;position: absolute;right: 0;top: 0;"></view>
				<view style="border-right: 10rpx solid #fff;border-bottom: 10rpx solid #fff;width: 25rpx;height: 25rpx;position: absolute;right: 0;bottom: 0;"></view>
				<view style="border-left: 10rpx solid #fff;border-bottom: 10rpx solid #fff;width: 25rpx;height: 25rpx;position: absolute;left: 0;bottom: 0;"></view>
			</view>
			<text style="position: absolute;top: 20%;color: #fff;left: 15%;z-index: 999;font-size: 34rpx;">请将车架号放入到框内,并点击拍照识别</text>
			<view style="position: absolute;left: 20rpx;top: 50rpx;z-index: 999;" @tap="back">
				<uni-icons type="back" size="60r" color="#fff"></uni-icons>
			</view>
		
		<!-- <canvas canvas-id="vinImgCanvas" id="vinImgCanvas"></canvas> -->
	</view>
</template>
<script>
	const app = getApp();
	export default {
		onLoad() {
		    this.ctx = uni.createCameraContext()
			// this.ctx2 = uni.createCanvasContext('vinImgCanvas', this)
			// this.listener = this.ctx.onCameraFrame((frame) => {
			// 	console.log(frame.data, frame.width, frame.height)
				
			// })
			// this.listener.start()
		},
		onUnload() {
			// this.listener.stop()
		},
		data() {
			return {
				ctx: {},
				ctx2: {},
				listener: {},
				cc: '',
			}
		},
		methods: {
			setCameraLock() {
				this.cameraLock = 1
			},
			back() {
				uni.navigateBack()
			},
			cameraError(e) {
				console.log('用户不允许使用', e)
			},
			stopError: function(e) {
				console.log('非正常终止',e)
			},
			chooseImgFile()
			{
				let that = this
				uni.chooseImage({
					count: 1, //默认9
					sizeType: ['compressed'], //可以指定是原图还是压缩图，默认二者都有
					sourceType: ['album'], //从相册选择
					success: function (res) {
						that.getVinRes(res.tempFilePaths[0])
					}
				});
			},
			takeImg()
			{
				let that = this
				this.ctx.takePhoto({
					success: function (res) {
						uni.navigateTo({url: '/pages/index/cameraData?isc=1&url='+res.tempImagePath});
						// // console.log(res.tempImagePath)
						// let ctx2 = uni.createCanvasContext('vinImgCanvas', that)
						// // let that2 = that
						// let vimImg = that.img2base64(res.tempImagePath)
						// that.cc = vimImg
						
						// ctx2.drawImage(res.tempImagePath)
						// ctx2.draw(false, function() {
						// 	let setX,setY,zzW,zzH
						// 	uni.getSystemInfo({
						// 		success:function(res2){
						// 			setX = parseInt(res2.screenWidth * 0.1)
						// 			setY = parseInt(res2.screenHeight * 0.4)
						// 			zzW = parseInt(res2.screenWidth * 0.8)
						// 			zzH = 100
						// 		}
						// 	})
						// 	console.log(setX,setY,zzW,zzH)
						// 	setTimeout(function() {
						// 		uni.canvasToTempFilePath({
						// 			x: setX,
						// 			y: setY,
						// 			width: zzW,
						// 			height: zzH,
						// 			canvasId: 'vinImgCanvas',
						// 			success: (res3) => {
						// 				console.log(res3.tempFilePath)
						// 				this.cc = res3.tempFilePath
						// 				// that2.getVinRes(that2.img2base64(res3.tempFilePath))
						// 			}
						// 		}, that)
						// 	},1000)
						// })
						
					}
				});
				
			},
			img2base64(url)
			{
				return 'data:image/jpeg;base64,'+uni.getFileSystemManager().readFileSync(url,'base64')
			},
			getVinRes(img)
			{
				uni.setStorageSync('vinBig', img);
				let data = {img:this.img2base64(img)}
				app.getApi('POST','data/vinOcr', data, 1, function(res){
					if (res.vin.length > 0) {
						uni.redirectTo({url: '/pages/index/cameraData?isc=0&isad=0&data='+JSON.stringify(res)+'&url='+img});
					} else {
						uni.redirectTo({url: '/pages/index/fetchData?isc=0&url='+img});
					}
				})
			}
		}
	}
</script>

<style>
	.btn-father{position: relative;margin: 0 70rpx;}
	.btn-father .btn-desc{color: #fff;position:absolute;font-size: 24rpx;width: 100rpx;left: 0;top: 110rpx;}
	.zz {
		position: absolute;
		left: 2%;
		top: 28%;
		width: 96%;
		height: 100px;
		box-shadow: rgba(0,0,0,.5) 0px 0px 0px 999px;
		z-index: 100;
	}
	#vinImgCanvas{
		width: 10000px;
		height: 10000px;
		opacity: 1;
	}
</style>
